import { PlayerData } from '@funtech-int/kp-graphql-sdk/player-sdk';

import { SDKPlayback } from '@kinopoisk-int/filmoscope';

import { getPsid } from './psid';

export interface EnhancedPlayback extends SDKPlayback {
    setVolume(volume: number): void;
    setRate(rate: number): void;
    enableABR(): void;
    psid: string;
    get videoToken(): string | undefined;
}

interface EnhancedPlaybackSettings {
    muted?: boolean;
    audioLanguage?: string | null;
    subtitleLanguage?: string | null;
    playerData?: PlayerData;
}

// this is clear anti-pattern, but we need it until SDKPlayback will be updated
// TODO: SAFTWEB-1841 (eliminate SDKPlayback decorator)
export const createEnhancedPlayback = (
    playback: SDKPlayback,
    settings: EnhancedPlaybackSettings
): EnhancedPlayback => {
    const { audioLanguage, subtitleLanguage } = settings;

    if (settings.muted) {
        playback.volume.emit(0);
    }

    if (audioLanguage) {
        const audioTrackValue = playback.audioTracks.value.find(
            (track) => track.language === audioLanguage
        )?.value;

        if (audioTrackValue) {
            playback.setAudioTrack(audioTrackValue);
        }
    }

    if (subtitleLanguage) {
        const subtitleTrackValue = playback.textTracks.value.find(
            (track) => track.language === subtitleLanguage
        )?.value;

        if (subtitleTrackValue) {
            playback.setTextTrack(subtitleTrackValue);
        }
    }

    return {
        ...playback,
        setVolume: (volume: number) => playback.volume.emit(volume),
        setRate: (rate: number) => playback.rate.emit(rate),
        enableABR: () => playback.isABREnabled.emit(true),
        get psid() {
            return getPsid();
        },
        videoToken:
            settings.playerData?.content.onlineStreams?.streams?.[0]?.streamMeta?.videoToken,
    };
};
